import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath } from 'react-router-dom';
import { IAppState } from '../interfaces/IAppState';

type ResetFunction = () => void;
type RouteConfig = {
  path: string;
  resetFn: ResetFunction;
};

export const useTeamChangeReset = (config: RouteConfig) => {
  const selectedTeamId = useSelector((state: IAppState) => state.organization.selectedTeam.teamId);

  useEffect(() => {
    const isMatchingRoute = matchPath(window.location.pathname, {
      path: config.path,
    });

    if (isMatchingRoute) {
      config.resetFn();
    }
  }, [selectedTeamId, config.path, config.resetFn]);
};
